import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { useSelector } from "react-redux";
import { loginAuth } from "../Redux/Auth/action";
import { useDispatch } from "react-redux";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

function Header() {
  const isAuth = useSelector((store) => store.isAuth.isAuth);
  // console.log(isAuth);

  const signupData = JSON.parse(localStorage.getItem("signup")) || null;

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleLogout = () => {
    localStorage.setItem("auth", JSON.stringify(false));
    dispatch(loginAuth(false));
    navigate("/");
  };

  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      right: -3,
      top: 13,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: "0 4px",
    },
  }));

  const cartData = JSON.parse(localStorage.getItem("cartData")) || [];

  const options = [
    "All Departments",
    "Auto",
    "Baby",
    "Beauty",
    "Books",
    "Business",
    "Cameras",
    "Clothes",
    "Collectibles",
    " Computers ",
    " Crafts ",
    " Electronics ",
    " Food and Drink ",
    " Garden ",
    " Gifts ",
    " Health & Nutrition ",
    " Hobbies, Workshops & Courses ",
    " Home Store ",
    " Jewelry ",
    " Movies ",
    " Music ",
    " Party Supplies ",
    " Pet Supplies ",
    " Posters ",
    " Shoes ",
    " Software ",
    " Sports Fan Shop ",
    " Sports and Fitness ",
    " Tools ",
    " Toys ",
    " Travel ",
    " Video Games ",
  ];

  return (
    <div className="headerBody">
      <section id="navbar">
        <div className="navbar-left">
          <Link to="/">
            <div id="logo">
              <img
                src="https://img.shop.com/Image/resources/logos/shop-logo-us.svg"
                alt=""
              />
            </div>
          </Link>
          <div id="menu-bar">
            <img
              src="https://img.shop.com/Image/resources/images/icon-menu-24px.svg"
              alt=""
            />
            <SwipeableTemporaryDrawer />
          </div>
        </div>
        <div id="navbar-right">
          <div id="navbar-right-top">
            <select name="" id="optionTag">
              {options.map((el, index) => (
                <option value="" key={index}>
                  {el}
                </option>
              ))}
            </select>
            <div id="header-right-top">
              <input type="text" placeholder="search SHOP.COM...." />
              <i className="fa fa-search" aria-hidden="true"></i>
            </div>
            <div id="header-left-top">
              <img
                src="https://img.shop.com/Image/header2013/motives-usa-can-100110-sculpting-concealer-banners-header1650486339409.svg"
                alt=""
              />
            </div>
          </div>
          <div id="navbar-right-bottom">
            <ul className="dept-list">
              <li className="dept-item">
                <Link to="">Exclusive Brands</Link>
              </li>
              <li className="dept-item">
                <Link to="/products">Stores</Link>
              </li>
              <li className="dept-item">
                <Link to="">Deals</Link>
              </li>
              <li className="dept-item">
                <Link to="">SHOP Travel</Link>
              </li>
              <li className="dept-item">
                <Link to="#">Departments</Link>
              </li>
              <li className="dept-item">
                <Link to="">ShopBuddy</Link>
              </li>
              <li className="dept-item">
                <Link to="">SHOP Local</Link>
              </li>
            </ul>
            <div className="nav-icons">
              {isAuth ? (
                <>
                  <Link to="/login">
                    <i className="fas fa-user-circle">
                      <span className="thinFont">
                        Hello , {signupData.name}{" "}
                      </span>
                    </i>
                  </Link>
                  <Link to="/" onClick={handleLogout}>
                    <span className="iconify" data-icon="tabler:logout"></span>
                  </Link>
                </>
              ) : (
                <Link to="/login">
                  <i className="fas fa-user-circle">
                    <span className="thinFont">Sign In</span>
                  </i>
                </Link>
              )}

              <Link to="">
                <i className="fas fa-redo-alt">
                  <span className="thinFont"> Orders</span>
                </i>
              </Link>
              <Link to="/cart">
                <IconButton aria-label="cart" className="cart">
                  <StyledBadge badgeContent={cartData.length} color="primary">
                    <ShoppingCartIcon />
                  </StyledBadge>
                </IconButton>
              </Link>
            </div>
          </div>
        </div>
        <div id="mobile-edition">
          <div id="mobile-header-left">
            <img
              id="mobile-logo"
              src="https://img.shop.com/Image/resources/logos/shop-s-logo-icon.svg"
              alt=""
            />
            <img
              id="mobile-menu"
              src="https://img.shop.com/Image/resources/images/icon-menu-24px.svg"
              alt=""
            />
          </div>
          <div id="mobile-header-right">
            <div id="mobile-header-right-top">
              <input type="text" placeholder="search SHOP.COM...." />
            </div>
            <div className="mobile-nav-icons">
              <Link to="">
                <i className="fas fa-user-circle"> </i>
              </Link>
              <Link to="">
                <i className="fas fa-redo-alt"> </i>
              </Link>
              <Link to="">
                <i className="fas fa-shopping-cart"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className="plain-area"></section>
    </div>
  );
}

export default Header;

//slider
function SwipeableTemporaryDrawer() {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <img
          src="https://img.shop.com/Image/resources/logos/shop-s-logo-icon.svg"
          alt=""
          width="40px"
        />
        <span
          style={{ fontSize: "20px", padding: "20px", fontWeight: "bolder" }}
        >
          SHOP.COM
        </span>
        <h4 style={{ padding: "20px" }}>Cetegories</h4>
        {[
          "All Departments",
          "Auto",
          "Baby",
          "Beauty",
          "Books",
          "Business",
          "Cameras",
          "Clothes",
          "Collectibles",
          " Computers ",
          " Crafts ",
          " Electronics ",
          " Food and Drink ",
          " Garden ",
          " Gifts ",
          " Health & Nutrition ",
          " Hobbies, Workshops & Courses ",
          " Home Store ",
          " Jewelry ",
          " Movies ",
          " Music ",
          " Party Supplies ",
          " Pet Supplies ",
          " Posters ",
          " Shoes ",
          " Software ",
          " Sports Fan Shop ",
          " Sports and Fitness ",
          " Tools ",
          " Toys ",
          " Travel ",
          " Video Games ",
        ].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      {["Categories"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button>
          <SwipeableDrawer
            anchor={"left"}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
